<template>
  <el-main>
    <el-row>      
      考试管理
    </el-row>
    <el-row>
      
          <el-row> 
                      <vxe-toolbar>
                            <template v-slot:buttons>
                              <a-space>
                              <a-icon type="team" />
                              <vxe-button icon="vxe-icon-square-plus" @click="insertOneXm()">新增项目</vxe-button>
                              <vxe-button @click="nianjiguanli">年级管理</vxe-button> 
                              <vxe-button @click="svrguanli">服务器管理</vxe-button>                              

                              <vxe-button @click="getQjExamList">刷新</vxe-button>                              
                              <vxe-input v-model="filterName1" type="search" placeholder="输入项目名搜索" @keyup="searchEvent1"></vxe-input>
                               
                              </a-space>
                        </template> 
                      </vxe-toolbar>
                    <vxe-table
                        ref="xTable"
                        height="400"
                        :seq-config="{startIndex: 0}"
                        :data="xmlist">                      
                        <vxe-column field="name"  title="项目" sortable></vxe-column>
                        <vxe-column field="nianji" title="年级"></vxe-column>   
                        <vxe-column field="date" title="日期"></vxe-column>
                        <vxe-column title="关联项目" width="100" show-overflow>
                          <template #default="{ row }">  
                            <vxe-button type="text" icon="vxe-icon-edit" @click="editGuanlianxm(row)"></vxe-button> 
                          </template>
                        </vxe-column> 

                        <vxe-column title="参与学校" width="100" show-overflow>
                          <template #default="{ row }">  
                            <vxe-button type="text" icon="vxe-icon-edit" @click="editCankaoschool(row)"></vxe-button> 
                          </template>
                        </vxe-column> 

                        <vxe-column title="数据汇总" width="100" show-overflow>
                          <template #default="{ row }">  
                            <vxe-button type="text" icon="vxe-icon-maximize" @click="datahuizong(row)"></vxe-button> 
                          </template>
                        </vxe-column>
                        <vxe-column title="成绩管理" width="100" show-overflow>
                          <template #default="{ row }">  
                            <vxe-button type="text" icon="vxe-icon-maximize" @click="scorexman(row)"></vxe-button> 
                          </template>
                        </vxe-column>

                        <vxe-column title="操作" width="100" show-overflow>
                          <template #default="{ row }">  
                            <vxe-button type="text" icon="vxe-icon-edit" @click="editEvent(row)"></vxe-button>           
                            <vxe-button type="text" icon="vxe-icon-delete" @click="removeEvent(row)"></vxe-button>
                          </template>
                        </vxe-column>
                    </vxe-table>

                      <vxe-modal v-model="showEdit" :title="selectRow ? '增加新项目' : '增加新项目'" width="800" min-width="600"  height="600" resize destroy-on-close>
                        <template #default>
                          <vxe-form :data="xmData" :rules="formRules" title-align="right" title-width="100" @submit="submitOneXmEvent">

                            <vxe-form-item field="name" title="项目名称" :span="12" :item-render="{}">
                              <template #default="{ data }">
                                <vxe-input v-model="data.name" placeholder="请输入项目名称"></vxe-input>
                              </template>
                            </vxe-form-item>

                            <vxe-form-item field="nianji" title="项目年级" :span="12" :item-render="{}">
                              <template #default="{ data }">                              
                                <vxe-select v-model="data.nianji" placeholder="请选择项目年级" clearable>
                                  <vxe-option v-for="i in tableDataNianji" :value="i.name"   :label="i.name"></vxe-option>
                                   
                                </vxe-select>

                              </template>
                              
                            </vxe-form-item> 

                            <vxe-form-item field="date" title="项目日期" :span="12" :item-render="{}">
                              <template #default="{ data }">                              
                                <vxe-input v-model="data.date" type="date" placeholder="请选择日期" clearable></vxe-input>
                              </template>
                             
                            </vxe-form-item>

                          

                            <vxe-form-item field="nianji" title="项目类型" :span="12" :item-render="{}">
                              <template #default="{ data }">                              
                                <vxe-select v-model="xmselexamtype" placeholder="请选择项目类型" clearable>
                                  <vxe-option v-for="i in tableDataExamType" :value="i"   :label="i"></vxe-option>
                                   
                                </vxe-select>

                              </template>
                              
                            </vxe-form-item>

                            <vxe-form-item field="kemu" title="项目科目" :span="12" :item-render="{}">
                              <template #default="{ data }">                             
                            
                            <a-select mode="tags" style="width: 100%" :defaultValue="xmselexamkemu" placeholder="Tags Mode" @change="handleChangeSelkemu">
                              <a-select-option v-for="i in tableDataExamKemu" :key="i">
                                {{i}}
                              </a-select-option>
                            </a-select>

                              </template>
                              
                            </vxe-form-item> 

                       
                         
                         
                            <vxe-form-item align="center" title-align="left" :span="24">
                              <template #default>
                                <vxe-button type="submit">提交</vxe-button>                             
                              </template>
                            </vxe-form-item>
                          </vxe-form>
                        </template>
                      </vxe-modal>

                      <vxe-modal v-model="showNianJiGuanli" :title="selectRow ? '年级管理' : '年级管理'" width="800" min-width="600" min-height="300" resize destroy-on-close>
                       
                            <vxe-table
                                    border
                                    show-overflow
                                    keep-source
                                    ref="xTableNianji"
                                    max-height="400"
                                    :data="tableDataNianji"
                                    :edit-config="{trigger: 'click', mode: 'cell', icon: 'vxe-icon-edit', showStatus: true}">
                                    <vxe-column type="checkbox" width="60"></vxe-column>
                                    <vxe-column type="seq" width="60"></vxe-column>
                                    <vxe-column field="name" title="名称" sortable :edit-render="{autofocus: '.vxe-input--inner', defaultValue: ''}">
                                      <template #edit="{ row }">
                                        <vxe-input v-model="row.name" type="text"></vxe-input>
                                      </template>
                                    </vxe-column>
                                  </vxe-table>
                             <vxe-toolbar>
                              <template #buttons>
                                <vxe-button @click="$refs.xTableNianji.removeCheckboxRow()">删除选中</vxe-button>
                                <vxe-button icon="vxe-icon-square-plus" @click="insertOneNianji(-1)">新增</vxe-button>
                                <vxe-button icon="vxe-icon-save" @click="saveNianji">保存</vxe-button>
                              </template>
                            </vxe-toolbar>

                      </vxe-modal>

                      <vxe-modal v-model="showSvrGuanli" :title="selectRow ? '服务器管理' : '服务器管理'" width="800" min-width="600" min-height="300" resize destroy-on-close>
                      
                            <vxe-table
                                    border
                                    show-overflow
                                    keep-source
                                    ref="xTableSvr"
                                    max-height="400"
                                    :data="tableDataSvr"
                                    :edit-config="{trigger: 'click', mode: 'cell', icon: 'vxe-icon-edit', showStatus: true}">
                                    <vxe-column type="checkbox" width="60"></vxe-column>
                                    <vxe-column type="seq" width="60"></vxe-column>
                                    <vxe-column field="name" title="名称" sortable :edit-render="{autofocus: '.vxe-input--inner', defaultValue: ''}">
                                      <template #edit="{ row }">
                                        <vxe-input v-model="row.name" type="text"></vxe-input>
                                      </template>
                                    </vxe-column>
                                    <vxe-column field="ip" title="IP" sortable :edit-render="{autofocus: '.vxe-input--inner', defaultValue: ''}">
                                      <template #edit="{ row }">
                                        <vxe-input v-model="row.ip" type="text"></vxe-input>
                                      </template>
                                    </vxe-column>
                                    <vxe-column field="yuming" title="域名" sortable :edit-render="{autofocus: '.vxe-input--inner', defaultValue: ''}">
                                      <template #edit="{ row }">
                                        <vxe-input v-model="row.yuming" type="text"></vxe-input>
                                      </template>
                                    </vxe-column>
                             </vxe-table>
                             <vxe-toolbar>
                              <template #buttons>
                                <vxe-button @click="$refs.xTableSvr.removeCheckboxRow()">删除选中</vxe-button>
                                <vxe-button icon="vxe-icon-square-plus" @click="insertOneSvr(-1)">新增</vxe-button>
                                <vxe-button icon="vxe-icon-save" @click="saveSvr">保存</vxe-button>
                              </template>
                            </vxe-toolbar>

                      </vxe-modal>


                     <vxe-modal v-model="dialogTableVisible" :title="selectRow ? '关联项目' : '关联项目'" width="800" min-width="600" min-height="300" resize destroy-on-close>


                    <vxe-table
                      border
                      class="checkbox-table"
                      ref="xTable4"
                      row-id="id"
                      :checkbox-config="{checkRowKeys: selkey}"
                      :row-config="{isHover: true}"
                      :data="svrxmlist"
                      @checkbox-change="selectChangeEvent"
                      >
                     
                      <vxe-column field="yuming" title="服务器"></vxe-column>
                      <vxe-column field="xm" title="项目" width="300"></vxe-column>
                      <vxe-column field="sel" type="checkbox" width="60"></vxe-column>
                    </vxe-table>

                    <vxe-toolbar>
                        <template #buttons>                       
                          <vxe-button icon="vxe-icon-save" @click="savexmxm">保存</vxe-button>
                        </template>
                      </vxe-toolbar>

                    </vxe-modal>

                    <vxe-modal v-model="schoolisible" :title="selectRow ? '参与学校' : '参与学校'" width="800" min-width="600" min-height="300" resize destroy-on-close>
                      选择项目: 
                        <a-select :value="selglyumingxm" style="width: 100%" @change="handleChangeglschool">
                            <a-select-option v-for="i in yumingxm" :key="i">
                              {{ i }}
                            </a-select-option>
                        </a-select>
                      <vxe-table
                              border
                              show-overflow
                              keep-source
                              ref="xTableschool"
                              height="400"
                              :data="onexmschoollist"
                              :edit-config="{trigger: 'click', mode: 'cell', icon: 'vxe-icon-edit', showStatus: true}">
                              <vxe-column type="checkbox" width="60"></vxe-column>
                              <vxe-column type="seq" width="60"></vxe-column>
                             
                              <vxe-column field="bianhao" title="学校编号" sortable :edit-render="{autofocus: '.vxe-input--inner', defaultValue: ''}" >    
                                <template #edit="{ row }">
                                  <vxe-input v-model="row.bianhao" type="text"></vxe-input>
                                </template>                      
                              </vxe-column>

                              <vxe-column field="school" title="学校名称" sortable :edit-render="{autofocus: '.vxe-input--inner', defaultValue: ''}">
                                <template #edit="{ row }">
                                  <vxe-input v-model="row.school" type="text"></vxe-input>
                                </template>
                              </vxe-column>
                              <vxe-column field="shi" title="市" sortable :edit-render="{autofocus: '.vxe-input--inner', defaultValue: ''}">
                                <template #edit="{ row }">
                                  <vxe-input v-model="row.shi" type="text"></vxe-input>
                                </template>
                              </vxe-column>
                              <vxe-column field="xianqu" title="县区" sortable :edit-render="{autofocus: '.vxe-input--inner', defaultValue: ''}">
                                <template #edit="{ row }">
                                  <vxe-input v-model="row.xianqu" type="text"></vxe-input>
                                </template>
                              </vxe-column>
                       </vxe-table>

                    <vxe-toolbar>
                      <template #buttons>                     
                        <vxe-button icon="vxe-icon-save" @click="saveSchool">保存</vxe-button>
                        <vxe-button @click="importschool">导入</vxe-button> 
                        <vxe-button @click="$refs.xTableschool.removeCheckboxRow()">删除选中</vxe-button>
                      </template>
                     
                    </vxe-toolbar>
                    

                  </vxe-modal>


                  <el-dialog :title="title" :visible.sync="ImportSchooListVisible" :close-on-press-escape="false" :close-on-click-modal="false">
                            <a-space>  
                            {{ user_school }}
                              <vxe-button @click="exportschoollistYangbiao">下载导入样表</vxe-button> 
                              <input type="file" ref="stFile" @change="importData">
                            </a-space>
                              <vxe-table
                                ref="xTableImport"
                                height="400"  
                                border
                                :seq-config="{startIndex: 0}"
                                :data="importSchoollistData">
                                <vxe-column type="seq" title="序号"  ></vxe-column>
                                <vxe-column field="bianhao"  title="编号" sortable></vxe-column>
                                <vxe-column field="school" title="名称"></vxe-column>
                                <vxe-column field="shi" title="市"></vxe-column>  
                                <vxe-column field="xianqu" title="县区"></vxe-column>  
                                     
                            </vxe-table>
                            <vxe-button @click="importSvrEvent">导入到服务器</vxe-button> 
                    </el-dialog> 

                    <vxe-modal v-model="schoolxmvisible" :title="selectRow ? '学校参与项目' : '学校参与项目'" width="800" min-width="600" min-height="300" resize destroy-on-close>
                      选择项目:
                      <a-select :default-value="onesvrguanlianxm" style="width: 100%" @change="handleChangexm">

                        svrguanlianxm
                            <a-select-option v-for="i in svrguanlianxm" :key="i">
                              {{ i }}
                            </a-select-option>
                        </a-select>
                        选择学校:  
                      <a-select  ref="xmschoolsel" mode="tags" style="width: 100%"  :value="guanlianxmschoollist" placeholder="Tags Mode" @change="handleChangeschoolxm">
                            <a-select-option v-for="i in allschoolgl" :key="i">
                              {{ i }}
                            </a-select-option>
                          </a-select>
                     <vxe-toolbar>
                      <template #buttons>
                     
                        <vxe-button icon="vxe-icon-save" @click="savexmguanlianschool">保存</vxe-button>
                      </template>
                    </vxe-toolbar>
                  </vxe-modal>

                  <vxe-modal v-model="showDatahuizong" :title="selectRow ? '数据汇总' : '数据汇总'" width="800" min-width="600" min-height="300" resize destroy-on-close>
                      选择项目:
                      <a-select :value="selhuizongxm" style="width: 100%" @change="handleChangeTongjixm">
                            <a-select-option v-for="i in huizongxmlist" :key="i">
                              {{ i }}
                            </a-select-option>
                        </a-select>
                      <vxe-table
                              border
                              show-overflow
                              keep-source
                              ref="xTablehuizong"
                              height="400"
                              :data="selhuizongxmdata"
                              :edit-config="{trigger: 'click', mode: 'cell', icon: 'vxe-icon-edit', showStatus: true}">
                              <vxe-column type="checkbox" width="60"></vxe-column>
                              <vxe-column type="seq" width="60"></vxe-column>
                             
                              <vxe-column field="school" title="学校名称" sortable :edit-render="{autofocus: '.vxe-input--inner', defaultValue: ''}">
                                <template #edit="{ row }">
                                  <vxe-input v-model="row.school" type="text"></vxe-input>
                                </template>
                              </vxe-column>
                              <vxe-column field="stcount" title="已传学生数" sortable :edit-render="{autofocus: '.vxe-input--inner', defaultValue: ''}">
                                <template #edit="{ row }">
                                  <vxe-input v-model="row.stcount" type="text"></vxe-input>
                                </template>
                              </vxe-column>
                              <vxe-column field="teachercount" title="已传教师数" sortable :edit-render="{autofocus: '.vxe-input--inner', defaultValue: ''}">
                                <template #edit="{ row }">
                                  <vxe-input v-model="row.teachercount" type="text"></vxe-input>
                                </template>
                              </vxe-column>
                       </vxe-table>
                    
                </vxe-modal>
                   
                  </el-row>
    </el-row>

  </el-main>
</template>
<script>
	import axios from 'axios'
	import qs from 'qs'
	import localStorage from 'localStorage'
  import ExcelJS from 'exceljs'
  import FileSaver from 'file-saver'
  import XEUtils from 'xe-utils'
  import VXETable from 'vxe-table'  
import { saveAs } from "file-saver";

	export default {
		data() {
		  return {
        tableDataNianji:[],
        tableDataExamType:['不分科','文理科','新高考'],
        tableDataExamKemu:['语文','数学','英语','物理','化学','生物','政治','历史','地理'],
        xmselexamtype:[],
      
        huizongxmlist:[],
        selhuizongxm:null,
        selhuizongxmdata:[],  
        huizongxmlistdata:[],

      showDatahuizong:false,
      xmname:'',  
      xm_id:'',
      showEdit:false,
      showNianJiGuanli:false,
      showSvrGuanli:false,

      xmlist:[],
			menulist: [],
      user_school:'',
      activeName: '0',
      svrxmlist:[],
      selkey:[],
      selsvrxmlst:[],
      tmpsavexmlist:[],
      xmallschoollist:[],
      xmcanyuschoollist:'',

      svrguanlianxm:[],
      onesvrguanlianxm:'',
      //关联项目对应学校 
      glxm_yumingxm:[],
      glxm_ymingxmschool:[],
      yumingxm:[],
      selglyumingxm:null,
      onexmschoollist:[],
      //当前选中的域名和项目名
      glxm_yuming:'',
      glxm_xm:'',

      guanlianxmname:'',
      guanlianxmschoollist:[],
      allschoolgl:[],
    
      tableDataSvr:[],
      svrStData: [
      ],
      svrTeacherData: [
      ],
      imortStData: [
      ],
      StData:[],
      teacherData:[],
      tmpStData:[],
     
      importTeacherData:[],

      importSchoollistData:[],

      dialogTableVisible: false,
      ImportSchooListVisible:false,
      schoolxmvisible:false,
      schoolisible:false,
      dialogTeacherTableVisible:false,
      filterName: '',
      tablePage1: {
                currentPage: 1,
                pageSize: 100,
                totalResult: 0
              },
      filterName1:'',    

		 
				sel_xm:'',
        sel_sb:'',
        sel_tizu:'',
        is_disable:true,
				is_jindu_disable:true,
				options:[],
				cascagerdefault: ["0", "0", ""],
        grade:'',
        xmData: {
                name: null,
                nianji: null,
                date: null,
                kaoshikemu:null,
                kaoshitype:null,
              },
        formRules: {
          
          name: [
            { required: true, message: '请输入项目名称' }
          ],
          nianji: [
            { required: true, message: '请输入项目年级' }
          ],
          date: [
            { required: true, message: '请输入项目日期' }
          ],
          examtype: [
            { required: true, message: '请输入项目类型' }
          ],
          xmselexamkemu:[{ required: true, message: '请输入科目' }],
         
        },



				
		  };
		},
    created () {
            this.searchEvent1()
        
          },
		mounted:function(){
		},

    activated() {

      this.getopt();//需要触发的函数

      },
          
	
		methods: {
      onChange(date, dateString) {
      console.log(date, dateString);
    },
    
      insertOneXm () {
              this.xmData = {
                name: null,
                nianji: null,
                date: null,
                kaoshitype:null,
                kaoshikemu:null,

              }
              this.selectRow = null
              this.showEdit = true
              axios.get('/scoreman?op=exmanlistnianji').then((res)=>{
               console.log(res.data)              

               this.tableDataNianji=res.data.nianjilist
            
               
           }).catch((res)=>{
               console.log(response)
           })
        },
        nianjiguanli(){
          axios.get('/scoreman?op=exmanlistnianji').then((res)=>{
               console.log(res.data)              

               this.tableDataNianji=res.data.nianjilist
               this.showNianJiGuanli=true
               
           }).catch((res)=>{
               console.log(response)
           })
         

        },
        svrguanli(){
          axios.get('/scoreman?op=exmanlistsvr').then((res)=>{
               console.log(res.data)              

               this.tableDataSvr=res.data.svrlist
               this.showSvrGuanli=true
               
           }).catch((res)=>{
               console.log(response)
           })
         
        },

        insertOneTeacher () {
              this.formDataTeacher = {
                zh: '',
                nm: '',
                km:'',
                sc: this.user_school,
                grade: '',
              }
              this.selectRow = null
              this.showEdit = true
        },
        async editEvent (row) {
               
               let name=row['name']
               const type = await VXETable.modal.confirm('您确定要删除:'+name+'的项目信息吗?')
               const $table = this.$refs.xTable
               if (type === 'confirm') {
                 $table.remove(row)
                 axios.post('/scoreman?op=exmandelonexm',qs.stringify({"xm_name":name})).then((res)=>{
                       console.log(res.data)
                       this.$alert(res.data, '提示', {
                           confirmButtonText: '确定',                 
                         })
                   }).catch((res)=>{
                   }) 
               }
             },

             
          async removeEvent (row) {
               
              let name=row['name']
              const type = await VXETable.modal.confirm('您确定要删除:'+name+'的项目信息吗?')
              const $table = this.$refs.xTable
              if (type === 'confirm') {
                $table.remove(row)
                axios.post('/scoreman?op=exmandelonexm',qs.stringify({"xm_name":name})).then((res)=>{
                      console.log(res.data)
                      this.$alert(res.data, '提示', {
                          confirmButtonText: '确定',                 
                        })
                  }).catch((res)=>{
                  }) 
              }
            },

            async removeTeacher (row) {
              console.log(row['zh'],row['nm'])
              let zh=row['zh']
              const type = await VXETable.modal.confirm('您确定要删除手机号:'+zh+'的教师信息吗?')
              const $table = this.$refs.xTable
              if (type === 'confirm') {
                $table.remove(row)
                axios.post('/scoreman?op=delOneSchoolTeacher',qs.stringify({"zh":zh})).then((res)=>{
                      console.log(res.data)
                      this.$alert(res.data, '提示', {
                          confirmButtonText: '确定',                 
                        })
                  }).catch((res)=>{
                  }) 
              }
            },
    
   
       
           searchEvent1 () {
              const filterName = XEUtils.toValueString(this.filterName1).trim().toLowerCase()
              if (filterName) {
                const filterRE = new RegExp(filterName, 'gi')
                const searchProps = ['kh', 'nm']
                const rest = this.svrStData.filter(item => searchProps.some(key => XEUtils.toValueString(item[key]).toLowerCase().indexOf(filterName) > -1))
                this.StData = rest.map(row => {
                  const item = Object.assign({}, row)
                  searchProps.forEach(key => {
                    item[key] = XEUtils.toValueString(item[key]).replace(filterRE, match => `${match}`)
                  })
                  return item
                })
              } else {
                this.StData = this.findList1()
              }
            },

      
      handleClick(tab, event) {
        console.log(tab, event)
        console.log(this.activeName)
        //获取对应科目上传信息
      },

 

      exportschoollistYangbiao() {
        const workbook = new ExcelJS.Workbook()
        const worksheet = workbook.addWorksheet('teacher')

        // 添加表头
        worksheet.addRow(['编号', '学校','市','县区'])

        // 添加数据
        worksheet.addRow(['1001', '一中','郑州','金水区'])

        // 导出Excel文件
        workbook.xlsx.writeBuffer().then(buffer => {
          const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          //自动列宽 begin
          for (let i = 0; i < worksheet.columns.length; i += 1) { 
              let dataMax = 0;
              const column = worksheet.columns[i];
              for (let j = 1; j < column.values.length; j += 1) {
                const columnLength = column.values[j].length;
                if (columnLength > dataMax) {
                  dataMax = columnLength;
                }
              }
              column.width = dataMax < 10 ? 10 : dataMax;
            }
            //自动列宽 end

          const filename = "导入学校样表" + ".xlsx";
          // saveAs(blob, filename);
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.download = filename
          link.click()
          window.URL.revokeObjectURL(url)
        })
      },


      //获取全局 exam 信息 
      getopt(){		
          console.log('请求开始')
          this.getQjExamList()
                  
      },

      getQjExamList() { 
         this.xmlist=[]

         this.filterName1=''
         this.tablePage1 = {           
                currentPage: 1,
                pageSize: 100,
                totalResult: 0
          }

         axios.post('/scoreman?op=exmanxmlist',qs.stringify({"grade":this.grade})).then((res)=>{
               console.log(res.data)
               this.xmlist=res.data.xmlist
               
           }).catch((res)=>{
               console.log(response)
           })
       },

 




   findList1 () {
               this.tablePage1.totalResult = this.svrStData.length
               this.StData = this.svrStData.slice((this.tablePage1.currentPage - 1) * this.tablePage1.pageSize, this.tablePage1.currentPage * this.tablePage1.pageSize)       

   },


    //增加单个项目        
    submitOneXmEvent () {
     
      this.xmData.kaoshitype=this.xmselexamtype
      this.xmData.kaoshikemu=this.xmselexamkemu
      axios.post('/scoreman?op=exminsertonexm',qs.stringify({"xmdate":JSON.stringify(this.xmData)})).then((res)=>{
               console.log(res.data)

               this.$alert(res.data, '提示', {
                  confirmButtonText: '确定',                 
                })               
           }).catch((res)=>{             
           })         
    },
    async editGuanlianxm(row){
 
      this.xmname=row['name']
      this.xm_id=row['id']
      axios.post('/scoreman?op=exmansvrxmlist',qs.stringify({"xmname":this.xmname})).then((res)=>{
               console.log(res.data)
               this.svrxmlist=res.data.svrxmlist
               this.tmpsavexmlist=res.data.savesvrxmlist

               this.selkey=[]
               
               for (let x=0;x<this.tmpsavexmlist.length;x++)
               {
                  let element=this.tmpsavexmlist[x]
                  for (let i=0;i<this.svrxmlist.length;i++)
                  {
                   
                    let onesvrxmlistitem=this.svrxmlist[i]
                    if ((onesvrxmlistitem['xm']==element['xm'])&&(onesvrxmlistitem['yuming']==element['yuming']))
                    {
                      let tmpid=onesvrxmlistitem['id']
                      this.selkey.push(tmpid)
                    }
                       
                  }

               }

      
              
               this.dialogTableVisible = true



              
           }).catch((res)=>{             
           })  
      
    },

    async editCankaoschool(row){

  
      this.xm_id=row['id']  
      this.xmname=row['name']
      axios.post('/scoreman?op=exmansvrxmschoollist',qs.stringify({"xmname":this.xmname})).then((res)=>{
               console.log(res.data)
               this.xmallschoollist=res.data.allschoollist
               this.xmcanyuschoollist=res.data.canyuschoollist

               this.glxm_yumingxm=res.data.guanlianxm
               this.yumingxm=res.data.yumingxm
               this.selglyumingxm=this.yumingxm[0]

               this.glxm_yuming=res.data.guanlianxm[0]['svr_yuming']
               this.glxm_xm=res.data.guanlianxm[0]['guanlianxm_name']
               this.onexmschoollist=res.data['onexmschoollist']



               console.log('参与学校'+this.xmcanyuschoollist)
               if (this.xmcanyuschoollist == false) 
               {
                console.log('is undefined')
                this.xmcanyuschoollist=''
               }
               this.schoolisible=true
              
           }).catch((res)=>{             
           }) 
    },
    
    async datahuizong(row){
          this.showDatahuizong=true
          this.xmname=row['name']
          axios.post('/scoreman?op=exmandatahuizong',qs.stringify({"xmname":this.xmname})).then((res)=>{
                  console.log(res.data)
               
                 // this.schoolisible=true
                 let tmparry=res.data
                 this.huizongxmlistdata=res.data
                 this.huizongxmlist=[]
                 for (let i=0;i<tmparry.length;i++)
                 {
                  this.huizongxmlist.push(tmparry[i]['xm'])
                 }
                // this.huizongxmlist=tmparry
                 this.selhuizongxm=tmparry[0]['xm']
                 this.selhuizongxmdata=tmparry[0]['data']

                 //const xx=this.$refs.selectVal
                // xx.value='11233'

                 console.log(huizongxmlist)

                  
              }).catch((res)=>{             
              }) 
    },
    async scorexman(row){

          this.xmname=row['name']
          this.xm_id=row['id']
          localStorage.setItem('xm_id',this.xm_id)
          localStorage.setItem('xm',this.xmname)
          //跳转到管理员成绩管理页面 scorexmain.vue

          this.$router.push({ path: '/scorexmain'});	
				
    },
    


    onexmglschool(onexm){
              const $xmschoolsel = this.$refs.xmschoolsel
            
              //单个项目关联的学校
              if (onexm.length>1)
                {
                          console.log('xxxxxx')
                          axios.post('/scoreman?op=exmanonexmguanlianschool',qs.stringify({"xmname":this.xmname,"guanlianxmname":onexm})).then((res)=>{
                          this.guanlianxmname=onexm
                          this.allschoolgl=res.data.allschoolgl
                          this.guanlianxmschoollist=res.data.allschoolglonexm
                         // $xmschoolsel.value=res.data.allschoolglonexm
                          this.schoolxmvisible=true
                          console.log('yyyy')
                          
                      }).catch((res)=>{             
                      }) 

                  
                }

    },

    
    

    async insertOneNianji (row) {
        const $table = this.$refs.xTableNianji
        const record = {
          name: '',
        }
        const { row: newRow } = await $table.insertAt(record, row)
        await $table.setActiveCell(newRow, 'name')
      },
    saveNianji(){
      const $table = this.$refs.xTableNianji
      const { insertRecords, removeRecords, updateRecords } = $table.getRecordset()     
      const body = { insertRecords, removeRecords, updateRecords }
     
      axios.post('/scoreman?op=exmansavenianji',qs.stringify({"nianjidata":JSON.stringify(body)})).then((res)=>{
               console.log(res.data)

               this.$alert(res.data, '提示', {
                  confirmButtonText: '确定',                 
                })               
           }).catch((res)=>{             
           })       

    },

    async insertOneSvr(row) {
        const $table = this.$refs.xTableSvr
        const record = {
          name: '',
        }
        const { row: newRow } = await $table.insertAt(record, row)
        await $table.setActiveCell(newRow, 'name')
      },
    saveSvr(){
      const $table = this.$refs.xTableSvr
      const { insertRecords, removeRecords, updateRecords } = $table.getRecordset()
           const body = { insertRecords, removeRecords, updateRecords }

      axios.post('/scoreman?op=exmansavesvr',qs.stringify({"svrdata":JSON.stringify(body)})).then((res)=>{
               console.log(res.data)

               this.$alert(res.data, '提示', {
                  confirmButtonText: '确定',                 
                })               
           }).catch((res)=>{             
           })       

    },
    async insertOneSchool(row) {
        const $table = this.$refs.xTableSchool
        const record = {
          name: '',
        }
        const { row: newRow } = await $table.insertAt(record, row)
        await $table.setActiveCell(newRow, 'name')
      },

    saveSchool(){      

      this.$refs.xTableschool.removeCheckboxRow()
      this.$refs.xTableSchool.getUpdateRecords()
      const $table = this.$refs.xTableSchool
      const { insertRecords, removeRecords, updateRecords } = $table.getRecordset()     
      const body = { insertRecords, removeRecords, updateRecords }

      let svr_yuming=this.glxm_yuming
      let svr_xm=this.glxm_xm  

      axios.post('/scoreman?op=exmansaveschool',qs.stringify({"xm_id":this.xm_id,"xm_name":this.xmname,"svr_yuming":svr_yuming,"svr_xm":svr_xm,"schoolistdata":JSON.stringify(body)})).then((res)=>{
               console.log(res.data)

               this.$alert(res.data, '提示', {
                  confirmButtonText: '确定',                 
                })               
           }).catch((res)=>{             
           })  
    },
    savexmxm(){     
     
      let selectRecords = this.$refs.xTable4.getCheckboxRecords()
      //console.log(this.selsvrxmlst)
      console.log(selectRecords)
      console.log(selectRecords[0]['xm'])
     axios.post('/scoreman?op=exmansavexmxm',qs.stringify({"xm_id":this.xm_id,"xmname":this.xmname,"xmxmdata":JSON.stringify(selectRecords)})).then((res)=>{
              console.log(res.data)

              this.$alert(res.data, '提示', {
                 confirmButtonText: '确定',                 
               })               
          }).catch((res)=>{             
          })  
   },
   selectAllEvent ({ checked }) {
              const records = this.$refs.xTable4.getCheckboxRecords()
              console.log(checked ? '所有勾选事件' : '所有取消事件', records)
            },
    selectChangeEvent ({ checked }) {
      const records = this.$refs.xTable4.getCheckboxRecords()
      console.log(checked ? '勾选事件' : '取消事件', records)
    },
    getSelectEvent () {
      let selectRecords = this.$refs.xTable4.getCheckboxRecords()
      VXETable.modal.alert(selectRecords.length)
    },
    savexmSchool(){
     
      axios.post('/scoreman?op=exmansavexmschool',qs.stringify({"xmname":this.xmname,"xmschooldata":JSON.stringify(this.xmcanyuschoollist)})).then((res)=>{
               console.log(res.data)

               this.$alert(res.data, '提示', {
                  confirmButtonText: '确定',                 
                })               
           }).catch((res)=>{             
           })  
    },
    savexmguanlianschool(){
     
     axios.post('/scoreman?op=examsavexmguanlianschool',qs.stringify({"xmname":this.xmname,"guanlianxmname":this.guanlianxmname,"xmguanlianschooldata":JSON.stringify(this.guanlianxmschoollist)})).then((res)=>{
              console.log(res.data)

              this.$alert(res.data, '提示', {
                 confirmButtonText: '确定',                 
               })               
          }).catch((res)=>{             
          })  
   },
    

    handleChangeSelXm(value) {
      console.log(`selected ${value}`)
      console.log(value.length)
      this.tmpsavexmlist=value
    },

    handleChangeSelkemu(value) {
      console.log(`selected ${value}`)
      console.log(value.length)
      this.xmselexamkemu=value
    },

    
    handleChangeSelType(value) {
      console.log(`selected ${value}`)
      console.log(value.length)
      this.xmselexamtype=value
    },

    
    handleChangeschool(value) {
   
      this.xmcanyuschoollist=value
    },
    handleChangexm(value) {
    
      this.guanlianxmname=value
      this.allschoolgl=[]
      this.guanlianxmschoollist=[]
      let onexm=value
      this.onexmglschool(onexm)
    },
    //汇总数据切换项目
    handleChangeTongjixm(value) {
    console.log('handleChangeTongjixm+++++')
    let oneselxm=value
    for (let i=0;i<this.huizongxmlistdata.length;i++)
    {
      if (this.huizongxmlistdata[i]['xm']==value)
      {
        this.selhuizongxm=value
        this.selhuizongxmdata=this.huizongxmlistdata[i]['data']
        break;
      }
    }
    console.log(value)
    
  },

   //关联学校数据切换项目
   handleChangeglschool(value) {
    console.log('handleChangeglschool+++++')
    this.onexmschoollist=[]
    let oneselxm=value
    for (let i=0;i<this.glxm_yumingxm.length;i++)
    {
      if (this.glxm_yumingxm[i]['svr_yuming']+'|'+this.glxm_yumingxm[i]['guanlianxm_name']==value)
      {
        this.selglyumingxm=value
        //this.selhuizongxmdata=this.huizongxmlistdata[i]['data']
        //从服务器获取对应项目学校信息 post id 返回具体信息

        this.glxm_yuming=this.glxm_yumingxm[i]['svr_yuming']
        this.glxm_xm=this.glxm_yumingxm[i]['guanlianxm_name']
        

          axios.post('/scoreman?op=exmanonexmschoollist',qs.stringify({"xmname":this.glxm_yumingxm[i]['guanlianxm_name'],"yuming":this.glxm_yumingxm[i]['svr_yuming']})).then((res)=>{
              console.log('从服务器获取对应项目学校信息')
              console.log(res.data)
                
            this.onexmschoollist=res.data['onexmschoollist']
              
           }).catch((res)=>{             
           }) 


        break;
      }
    }
    console.log(value)
    
  },
    handleChangeschoolxm(value) {

      this.guanlianxmschoollist=value
    },

    importData(event) {
          let file = event.target.files[0]
          let reader = new FileReader()

          reader.onload = () => {
            console.log('111')
            let buffer = reader.result
            let workbook = new ExcelJS.Workbook()

            workbook.xlsx.load(buffer).then(() => {
              let worksheet = workbook.worksheets[0]
              //检测导入表题头是否合规 begin
              let dataIsValid=true
              if (worksheet.columns.length>=4)
              {
                let column = worksheet.columns[0];
                if (column.values[1]!='编号')
                {
                  dataIsValid=false
                }
                   column = worksheet.columns[1];
                if (column.values[1]!='学校')
                {
                  dataIsValid=false
                }
                column = worksheet.columns[2];
                if (column.values[1]!='市')
                {
                  dataIsValid=false
                }
                column = worksheet.columns[3];
                if (column.values[1]!='县区')
                {
                  dataIsValid=false
                }
                

              }
              else
              {
                dataIsValid=false
              }
              //检测导入表题头是否合规 end
              if (dataIsValid==true)
              {
                  this.importSchoollistData = []
                  for (let i = 2; i <= worksheet.rowCount; i++) {
                    let bianhao = worksheet.getCell(`A${i}`).value
                    let school= worksheet.getCell(`B${i}`).value
                    let shi = worksheet.getCell(`C${i}`).value
   
                    let xianqu= worksheet.getCell(`D${i}`).value
                     
                    this.importSchoollistData.push({ bianhao,school,shi,xianqu })
                  }
                   
              }
              else
              {
                this.$alert('导入数据不合规,请下载样表!', '提示', {
                  confirmButtonText: '确定',
                 
                })
              }
            })
            
          }

          reader.readAsArrayBuffer(file)
          this.$refs.stFile.value = ''
        },


    importschool(){
      //导入学校列表1   
        this.importSchoollistData=[]
        this.ImportSchooListVisible=true
    },
    importSvrEvent() {     
      //导入学校列表2         
   
         let svr_yuming=this.glxm_yuming
         let svr_xm=this.glxm_xm     

         axios.post('/scoreman?op=importSchoollist',qs.stringify({"xm_id":this.xm_id,"xm_name":this.xmname,"svr_yuming":svr_yuming,"svr_xm":svr_xm,"schoolistdata":JSON.stringify(this.importSchoollistData)})).then((res)=>{
               console.log(res.data)

               this.$alert(res.data, '提示', {
                  confirmButtonText: '确定',                 
                })
               
           }).catch((res)=>{
           })
   },

    
          
		}
	  };
	</script>
	<style lang="scss" scoped>

  </style>
  